import { findInEnum, findValueInEnum, maybe } from "@saleor/misc";
import {
  paymentChannelEnum,
  PaymentEventsFilterKeys,
  PaymentEventsListFilterOpts
} from "@saleor/paymentEvents/components/PaymentEventsListPage/filters";
import {
  PaymentChannelCodeEnum,
  PaymentGatewayEnum
} from "@saleor/types/globalTypes";

import { IFilterElement } from "../../../components/Filter";
import {
  createFilterTabUtils,
  createFilterUtils,
  getSingleEnumValueQueryParam,
  getSingleValueQueryParam
} from "../../../utils/filters";
import {
  PaymentEventsListUrlFilters,
  PaymentEventsListUrlFiltersEnum,
  PaymentEventsListUrlQueryParams
} from "../../url";
export const PAYMENT_EVENTS_FILTERS_KEY = "PaymentEventFilter";

export function getFilterOpts(
  params: PaymentEventsListUrlFilters
): PaymentEventsListFilterOpts {
  const paymentMethod = params.paymentMethodType?.split(" ");
  const paymentMethodType = paymentMethod ? paymentMethod[0] : null;
  const channelCode = paymentMethod ? paymentMethod[1] : null;
  return {
    channelCode: {
      active: !!channelCode,
      value: maybe(() =>
        channelCode
          ? findValueInEnum(channelCode, PaymentChannelCodeEnum)
          : null
      )
    },
    orderCode: {
      active: !!params.orderCode,
      value: maybe(() => params.orderCode, "")
    },
    paymentMethodType: {
      active: !!paymentMethodType,
      value: maybe(() => paymentMethodType, "")
    },
    reference: {
      active: !!params.reference,
      value: maybe(() => params.reference, "")
    },
    transactionId: {
      active: !!params.transactionId,
      value: maybe(() => params.transactionId, "")
    }
  };
}

export function getFilterVariables(params: PaymentEventsListUrlFilters) {
  const paymentMethod = params.paymentMethodType?.split(" ");
  const paymentMethodType = paymentMethod ? paymentMethod[0] : null;
  const channelCode = paymentMethod ? paymentMethod[1] : null;
  return {
    channelCode: maybe(() => findInEnum(channelCode, PaymentChannelCodeEnum)),
    order_code: maybe(() => params.orderCode, null),
    paymentMethodType: maybe(() =>
      findInEnum(paymentMethodType, PaymentGatewayEnum)
    ),
    reference: maybe(() => params.reference, null),
    search: params.query,
    transaction_id: maybe(() => params.transactionId, null)
  };
}

export function getFilterQueryParam(
  filter: IFilterElement<PaymentEventsFilterKeys>
): PaymentEventsListUrlFilters {
  const { name } = filter;

  switch (name) {
    case PaymentEventsFilterKeys.orderCode:
      return getSingleValueQueryParam(
        filter,
        PaymentEventsListUrlFiltersEnum.orderCode
      );
    case PaymentEventsFilterKeys.transactionId:
      return getSingleValueQueryParam(
        filter,
        PaymentEventsListUrlFiltersEnum.transactionId
      );
    case PaymentEventsFilterKeys.paymentMethodType:
      return getSingleEnumValueQueryParam(
        filter,
        PaymentEventsListUrlFiltersEnum.paymentMethodType,
        paymentChannelEnum
      );
    case PaymentEventsFilterKeys.reference:
      return getSingleValueQueryParam(
        filter,
        PaymentEventsListUrlFiltersEnum.reference
      );
  }
}

export const {
  deleteFilterTab,
  getFilterTabs,
  saveFilterTab
} = createFilterTabUtils<PaymentEventsListUrlFilters>(
  PAYMENT_EVENTS_FILTERS_KEY
);

export const { areFiltersApplied, getActiveFilters } = createFilterUtils<
  PaymentEventsListUrlQueryParams,
  PaymentEventsListUrlFilters
>({
  ...PaymentEventsListUrlFiltersEnum
});
